import React, { useState, useEffect } from "react";
import { Button, IconButton, InputAdornment, Typography } from "@mui/material";
import { border, Box } from "@mui/system";
// Helpers
import ImageHelper from "../../Helpers/ImageHelper";
import axios from "axios";
import {
  fetchProducts,
  fetchUnlabeledProducts,
  packageDetails,
  sponsorDiscount,
} from "../../redux/shoppingActions";
import * as actionTypes from "../../redux/shoppingTypes";
// Custom Styles
import HeroSectionStyle from "./HeroSectionStyle";
import FilledButton from "../Ui-Components/Buttons/FilledButton/FilledButton";
import ConstantHelper from "../../Helpers/ConstantHelper";
import ColorHelper from "../../Helpers/ColorHelper";
import EventSelectBox from "../Ui-Components/EventSelectBox/EventSelectBox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";
import FontHelper from "../../Helpers/FontHelper";
import PreOrderDownloadForm from "../Modals/PreOrderDownloadForm/PreOrderDownloadForm";
import PreOrderDownloadModal from "../Modals/PreOrderDownloadForm/PreOrderDownloadModal";
import IconHelper from "../../Helpers/IconHelper";
import ImageUploadModal from "../Modals/ImageUploadModal/ImageUploadModal";
import AdvanceSearchComp from "../AdvanceSearchComp/AdvanceSearchComp";
import { getResults } from "../../redux/shoppingReducer";
import Cookies from "../Cookies/Cookies";
import { clearCart } from "../../redux/shoppingActions";
import { useDispatch, useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import HeroBottomStripe from "../HeroBottomStripe/HeroBottomStripe";
import "./HeroSection.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSnackbar } from "notistack";
import DateOfBirthSelectBox from "../Ui-Components/EventSelectBox/DateOfBirthSelectBox";
import PreorderModal from '../Modals/PreorderModal';

const HeroSection = (props) => {
  const snack = useSnackbar();
  const [openCFModal, setOpenCFModal] = useState(false); // PreOrder Download modal state
  const [openUploadImageModal, setOpenUploadImageModal] = useState(false); // Upload Image modal state
  const [searchType, setSearchType] = useState("bib"); // New state for search type toggle

  const { selectedEvent, setSelectedEvent, events, HeroImage } = props;

  const [advanceComp, setAdanceComp] = useState(false);
  const navigate = useNavigate();
  const [BIBValue, setBIBValue] = useState("");
  const dispatch = useDispatch();
  const productBiB = useSelector((state) => state.shop?.products?.bibNumber);
  const [isLoading, setIsLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState({});
  const tabRef = React.useRef();

  // Remove the achievements eligibility data when event changes
  useEffect(() => {
  if (selectedEvent) {
    localStorage.removeItem("achievementsEligibility");
    localStorage.removeItem("event_template_data");
    localStorage.removeItem("event_photos_data");
  }
}, [selectedEvent?.event_id]);

  const getSearchResults = async (event) => {
    dispatch(packageDetails(""));
    if (BIBValue !== productBiB) {
      dispatch({
        type: actionTypes.ADD_TO_CART,
        payload: {
          cartInfo: [],
        },
      });
      setIsLoading(false);
    }

    if (!BIBValue) {
      navigate("/");
      setIsLoading(false);
    } else {
      setIsLoading(true);
      localStorage.setItem("showModal", true)
      dispatch(sponsorDiscount({ apply: false, photoID: [] }));
      const ID = localStorage.getItem("ID");
      dispatch(fetchProducts(selectedEvent.event_name, BIBValue, selectedEvent.event_id, ID, ""))
        .then((res) => {
          if (res?.data?.StatusCode === 200) {
            setIsLoading(false);
            
          // Store achievements eligibility data
          if (res?.data?.result?.achievementsEligibility) {
            localStorage.setItem(
              "achievementsEligibility", 
              JSON.stringify(res.data.result.achievementsEligibility)
            );
          }

            if (res?.data?.result?.photo.length > 0) {
              localStorage.setItem("bibId", res.data.result.bibNumber);
              navigate("/products");
            } else {
              snack.enqueueSnackbar({
                variant: "warning",
                message: res?.data?.Message,
              });
            }
          } else {
            setIsLoading(false);
            snack.enqueueSnackbar({
              variant: "warning",
              message: res?.data?.Message,
            });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          snack.enqueueSnackbar({
            variant: "error",
            message: "Server Error",
          });
          console.log(err);
        });
    }
  };

  const handleSelfieSearch = () => {
    setOpenUploadImageModal(true);
  };

  const handleAdvanceSearchClick = () => {
    setAdanceComp(!advanceComp);
  };

  const handlePreBookedBtn = (url) => {
    navigate(`${url}`);
  };

  const handleUnlabeledProducts = () => {
    dispatch(clearCart());
    dispatch(
      fetchUnlabeledProducts(selectedEvent.event_name, selectedEvent.event_id)
    )
      .then((res) => {
        localStorage.setItem("bibId", res.data.result.bibNumber);
        navigate("/unlabeled-events");
      })
      .catch((err) => console.log(err));
  };

  const keyDownHandler = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (searchType === "bib") {
        getSearchResults();
      } else {
        handleSelfieSearch();
      }
    }
    if (event.key === "Tab") {
      event.preventDefault();
      tabRef.current.focus();
    }
  };

  const keyEnterHandler = (event) => {
    if (event.key === "Enter") {
      // Handle enter key
    }
  };

  const handlePreOrder = () => {
    navigate(`/preorder?eventId=${selectedEvent?.event_id}`)
  }

  // Toggle button styles
  const toggleButtonStyle = (isActive) => ({
    flex: 1,
    py: 1.5,
    px: 3,
    borderRadius: "8px",
    border: isActive ? "none" : `2px solid ${ColorHelper.WhiteColor}`,
    backgroundColor: isActive ? ColorHelper.WhiteColor : "transparent",
    color: isActive ? ColorHelper.PrimaryColor : ColorHelper.WhiteColor,
    fontFamily: FontHelper.fBold || "Arial",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textAlign: "center",
    "&:hover": isActive ? {} : {
      backgroundColor: ColorHelper.WhiteColor,
      color: ColorHelper.PrimaryColor,
    }
    
  });

  const HeroDesign = () => (
    <>
      <PreorderModal />
      <Box sx={HeroSectionStyle.formContainerWrapper}>
        <Box sx={HeroSectionStyle.formContainer}></Box>
      </Box>
      <Box sx={{ position: "relative" }} className="heroImageAlignInput">
        <Box
          sx={{
            ...HeroSectionStyle.img_container,
            ...(advanceComp && {
              "#HeroImage": {
                minHeight: {
                  xs: "110vh",
                  sm: "92vh",
                  md: "95.2vh",
                  lg: "86.2vh",
                },
              },
            }),
          }}
        >
          <Box
            sx={{
              ...HeroSectionStyle.overlay,
              ...(props.selectedEvent != "" && {
                backgroundColor: "#000",
              }),
              ...(advanceComp && {
                minHeight: {
                  xs: "110vh",
                  sm: "92vh",
                  md: "95.2vh",
                  lg: "86.2vh",
                },
              }),
            }}
          ></Box>
          <LazyLoadImage
            src={HeroImage?.image}
            style={HeroSectionStyle.HeroImage}
            id="HeroImage"
            width={1350} height={360}
            loading="lazy"
            alt={HeroImage?.alt}
          />

          <Box sx={{ ...HeroSectionStyle.contents }}>
            <Typography
              sx={HeroSectionStyle.Herotitle}
              variant="h6"
              component="h2"
            >
              {ConstantHelper.Herotitle}
            </Typography>

            <Box sx={HeroSectionStyle.serachContainer}>
              <EventSelectBox
                selectedEvent={selectedEvent}
                setSelectedEvent={setSelectedEvent}
                events={events}
                setEventDetails={setEventDetails}
                setIsLoading={setIsLoading}
              />

              {selectedEvent && selectedEvent?.issearchable == 1 && (
                <>
                  {/* Search Form Container - Stacked Layout */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: { xs: "100%", md: "450px" },
                      gap: 1,
                      px: { xs: 0, lg: 0 },
                      marginTop: { xs: '1rem', sm: '1rem' }
                    }}
                  >
                    {/* Toggle Buttons for Search Type */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                        <Box
                          sx={toggleButtonStyle(searchType === "bib")}
                          onClick={() => setSearchType("bib")}
                        >
                          Search by BIB
                        </Box>
                     
                      {selectedEvent.selfiesearch == 1 && (
                        <Box
                          sx={toggleButtonStyle(searchType === "selfie")}
                          onClick={() => setSearchType("selfie")}
                        >
                          Search by Selfie
                        </Box>
                      )}
                    </Box>

                    {/* Search Input - Only show for BIB search */}
                    {searchType === "bib" && (
                      <TextField
                        id="outlined-basic"
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontWeight: { xs: 300, md: 600 },
                          color: ColorHelper.WhiteColor,
                          background: "rgba(244, 248, 255, 0.2)",
                          borderRadius: "8px",
                          backdropFilter: { xs: "unset", sm: "blur(8px)" },
                          border: "1px solid #FFFFFF",
                          width: "100%",
                          input: {
                            fontSize: "15px",
                            height: { xs: "2.2rem", md: "2.5rem", lg: "2.5rem" },
                            color: ColorHelper.WhiteColor,
                            "&::placeholder": {
                              color: ColorHelper.WhiteColor,
                            },
                          },
                          "& fieldset": { border: "none" },
                        }}
                        size="small"
                        placeholder="Enter your BIB number (ex: TT20608)"
                        onChange={(e) => {
                          setBIBValue(e.target.value);
                        }}
                        variant="outlined"
                        onKeyDown={keyDownHandler}
                        onKeyPress={keyEnterHandler}
                      />
                    )}

                    {/* Find My Photos Button */}
                    <Button
                      variant="contained"
                      onClick={searchType === "bib" ? getSearchResults : handleSelfieSearch}
                      sx={{
                        bgcolor: ColorHelper.WhiteColor,
                        color: ColorHelper.PrimaryColor,
                        fontFamily: FontHelper.fBold,
                        fontSize: "16px",
                        fontWeight: 400,
                        py: 1.5,
                        borderRadius: "8px",
                        width: "100%",
                        textTransform: "none",
                        "&:hover": {
                          bgcolor: "#fff",
                        },
                      }}
                    // disabled={searchType === "bib" && !BIBValue}
                    >
                      {searchType === "bib" ? "Find My Photos" : "Upload a Selfie"}
                    </Button>

                    {/* Pre-Booked Photos and Unlabeled Photos Links */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                        mt: 2,
                        width: "100%",
                      }}
                    >
                     {selectedEvent && selectedEvent.preorder_allowed == 1 && (
                       <Typography
                         sx={{
                           color: ColorHelper.WhiteColor,
                           fontFamily: FontHelper.fRegular,
                           fontSize: { xs: 14, md: 16 },
                           cursor: "pointer",
                          textDecoration: "underline",
                          "&:hover": {
                            color: ColorHelper.LightYellow2,
                          },
                        }}
                        onClick={() => setOpenCFModal(true)}
                      >
                        Pre-Booked Photos
                      </Typography>)}

                      {selectedEvent && selectedEvent.showunlabeled == 1 && (
                        <Typography
                          sx={{
                            color: ColorHelper.WhiteColor,
                            fontFamily: FontHelper.fRegular,
                            fontSize: { xs: 14, md: 16 },
                            cursor: "pointer",
                            textDecoration: "underline",
                            "&:hover": {
                              color: ColorHelper.LightYellow2,
                            },
                          }}
                          onClick={() => {
                            handleUnlabeledProducts();
                          }}
                        >
                          Unlabeled Photos
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
            </Box>

            {selectedEvent && (selectedEvent.preorder_allowed == 1 && selectedEvent.issearchable == 0) &&
              <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
                justifyContent: 'center',
                marginTop: { xs: '2rem', sm: '2rem' }
              }}>
                <Button
                  variant="contained"
                  onClick={handlePreOrder}
                  sx={{
                    bgcolor: '#3F0E77',
                    color: 'white',
                    fontFamily: 'Urbanist-Regular',
                    fontSize: '14px',
                    '&:hover': {
                      bgcolor: '#2F0A5A',
                    },
                    padding: "5px 40px",
                    width: { xs: '100%', sm: 'auto' },
                    minWidth: { sm: '120px' }
                  }}
                >
                  Pre Order
                </Button>
              </Box>
            }

            {advanceComp && (
              <Box
                sx={{
                  width: { xs: "100%", sm: "auto", position: "relative" },
                  marginTop: { xs: '2rem', sm: '2rem' },
                  px: 3,
                }}
              >
                <Box sx={{ ...HeroSectionStyle.AdvanceSection }}>
                  <Typography sx={HeroSectionStyle.AdvanceSectionTitle}>
                    {ConstantHelper.AdvanceSectionTitle}
                  </Typography>
                  <Box
                    onClick={() => setAdanceComp(false)}
                    sx={{
                      position: "absolute",
                      top: "15px",
                      right: "15px",
                      cursor: "pointer",
                    }}
                  >
                    <IconHelper.CloseIcon2 />
                  </Box>
                  <AdvanceSearchComp
                    eventTheme={props.eventTheme}
                    eventYear={props.eventYear}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );

  useEffect(() => {
    HeroDesign();
  }, [selectedEvent]);

  return (
    <Box>
      <div style={{ display: isLoading ? "flex" : "none", zIndex: "9" }} className="modal">
        <div className="modal-content">
          <div className="loader"></div>
          <div className="modal-text">Processing...</div>
        </div>
      </div>
      <>
        <Box sx={HeroSectionStyle.sectionWrapper}>
          {HeroDesign()}
          <PreOrderDownloadModal
            open={openCFModal}
            selectedEvent={selectedEvent}
            onClose={() => setOpenCFModal(false)}
            setOpenCFModal={setOpenCFModal}
          />

          <ImageUploadModal
            open={openUploadImageModal}
            onClose={() => setOpenUploadImageModal(false)}
          />
        </Box>
      </>
    </Box>
  );
};

export default HeroSection;